import React from 'react';

const SyncSvg = () => {
  return (
    <svg
      width="380"
      height="380"
      viewBox="0 0 380 380"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M194.5 86.3636V138.182L270.25 69.0909L194.5 0V51.8182C110.796 51.8182 43 113.655 43 190C43 217.118 51.7112 242.336 66.4825 263.582L94.1312 238.364C85.6094 224.027 80.875 207.445 80.875 190C80.875 132.827 131.817 86.3636 194.5 86.3636ZM322.518 116.418L294.869 141.636C303.201 156.145 308.125 172.555 308.125 190C308.125 247.173 257.183 293.636 194.5 293.636V241.818L118.75 310.909L194.5 380V328.182C278.204 328.182 346 266.345 346 190C346 162.882 337.289 137.664 322.518 116.418V116.418Z"
        fill="#067AC1"
      />
    </svg>
  );
};

export default SyncSvg;